/*global angular */
/*jslint node: true */

'use strict';

var tab = angular.module('msTab', []);

// angular $location provider patch.
tab.run(['$route', '$rootScope', '$location', function ($route, $rootScope, $location) {
    var original = $location.path;
    $location.path = function (path, reload) {
        if (reload === false) {
            var lastRoute = $route.current;
            var un = $rootScope.$on('$locationChangeSuccess', function () {
                $route.current = lastRoute;
                un();
            });
        }
        return original.apply($location, [path]);
    };
}]);


tab.service('msTab', ['$compile', '$document', '$location', '$animate', '$routeParams', function ($compile, $document, $location, $animate, $routeParams) {
    var template = '<ul ng-if="tabMode()" class="nav navbar-nav">' +
        '<li ng-repeat="item in site.settings.tabs" ng-style="tabStyle($index)">' +
        '<a ng-click="msTab.switchTab($index)" style="cursor:pointer;">{{item.name}}</a>' +
        '</li>' +
        '</ul>' +
        '<span ng-if="mode.edit && tabMode()" style="position: absolute;">' +
        '<button ng-click="addTab(\'tab\'+site.settings.tabs.length)">add tab</button>' +
        '<input type="text" ng-model="site.settings.tabs[activeTab].name"/>' +
        '<button ng-click="removeTab(activeTab)">remove tab</button>' +
        '</span>';

    var msTab = {};

    return {
        config: {
            enable_explicit: true,
            type: ['site'],
            title: 'Tabs',
            template: '<md-switch ng-model="subject.settings.msExt.msTab">tabs</md-switch>',
            visible: function (context_type) {
                return context_type == 'site';
            }
        },
        init: function (scope, context_element, publish_action) {
            scope.msTab = msTab;
            var subject = scope.site;
            if (!subject.settings) subject.settings = {};
            if (!subject.settings.msExt) subject.settings.msExt = {};
            return;


            scope.$watch('site.settings.msExt.msTab', function (value) {
                if (!value) return;
                scope.site.settings.showNav = false;
                if (!subject.settings.tabs) subject.settings.tabs = [];
                if (subject.settings.tabs.length === 0 || subject.settings.tabs[0].type != 'index') {
                    subject.settings.tabs.splice(0, 0, {name: 'home', type: 'index'});
                }
                scope.activeTab = 0;

                if (scope.domainParts.length > 1) {
                    var tabName = scope.domainParts[1];
                    angular.forEach(subject.settings.tabs, function (tab, index) {
                        if (tab.name == tabName) {
                            scope.msTab.switchTab(index);
                            scope.activeTab = index;
                        }
                    });
                }
            }, true);

            var element = angular.element(context_element.querySelector('.navbar-main'));
            var linkFn = $compile(template);
            var content = linkFn(scope);
            element.prepend(content);


            scope.tabMode = function () {
                return scope.site.settings ? scope.site.settings.msExt.msTab === true : false;
            };

            scope.removeTab = function (index) {
                if (index === 0) return;

                scope.site.settings.tabs.splice(index, 1);

                if (index == scope.activeTab) {
                    scope.msTab.switchTab(0);
                }
            };

            scope.addTab = function (tab_name) {
                scope.site.settings.tabs.push({
                    name: tab_name,
                    sections: [{
                        type: 'main',
                        groups: [
                            {
                                "settings": {},
                                "slots": [
                                    {
                                        "type": "headline", "content": "ABschNITT 5: VIELE Bilder",
                                        "settings": {"slug": "neuer-title-3", "title": "Neuer Title 3"}
                                    }
                                ]
                            },
                            {
                                "settings": {},
                                "slots": [{
                                    "type": "image",
                                    "content": "/img/default/5e7cc38a-476b-4542-be1c-ececc9be0e3f.png"
                                }]
                            }
                        ]
                    }]
                });
            };

            scope.tabStyle = function (index) {
                if (index == scope.activeTab) {
                    return {'background-color': 'rgba(0,0,0,0.2)'};
                } else {
                    return null;
                }
            };

            scope.msTab.switchTab = function (index) {
                $animate.enabled(false);
                // document.body.style.display = 'none';
                scope.activeTab = index;
                if (index === 0) {
                    scope.sections = scope.site.sections;
                } else {
                    scope.sections = scope.site.settings.tabs[index].sections;
                }

                if (index === 0) {
                    if (scope.domainParts.length > 1) {
                        $location.path('/site/' + scope.domain + (scope.mode.edit ? '/edit' : ''), false);
                    }
                } else {

                    var name = scope.site.settings.tabs[index].name;
                    if (scope.domainParts.length < 2 || scope.domainParts[1] != name) {
                        if (scope.domainParts.length) scope.domainParts.push(name);
                        scope.domainParts[1] = name;
                        $location.path('/site/' + scope.domain + '/' + name + (scope.mode.edit ? '/edit' : ''), false);
                    }
                }

                scope.domainParts = $routeParams.domain.split('/');
                /** @type {string} */
                scope.domain = scope.domainParts[0];

                setTimeout(function () {
                    $animate.enabled(true);
                }, 500);
            };
        }
    };
}]);
